import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
export function ReviewsGrid() {
  return <section className="py-24" data-id="element-2926">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2927">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2928">
          {STORM_REVIEWS.map((review, idx) => <ReviewCard key={idx} quote={review.quote} name={review.name} label={review.label} data-id="element-2929" />)}
        </div>
        <p className="text-center text-sm text-gray-warm mt-12 max-w-2xl mx-auto" data-id="element-2930">
          Reviews shown are representative excerpts of feedback from Storm
          Taekwondo families. Storm Taekwondo holds a 5.0 rating from 201
          reviews.
        </p>
      </div>
    </section>;
}